import { hot } from "react-hot-loader/root";
import React from "react";
import TwitchContext from "../../../common/context/TwitchContext";
import "../../../assets/styles/index.scss";
import Base from "./layout/Base";
import useBaseFontResize from "../../../common/hooks/useBaseFontResize";

function App(): JSX.Element {
  useBaseFontResize();

  return (
    <TwitchContext>
      <Base />
    </TwitchContext>
  );
}

export default hot(App);
